var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiClientServices from "..";
function sendDataToMultiMediaService(formData, params) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = "/proctor-gateway/upload";
        // const url = `http://all7018/multimedia-uploader/video`;
        try {
            const response = yield apiClientServices.post(url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                params,
            });
            return response === null || response === void 0 ? void 0 : response.data;
        }
        catch (error) {
            throw error;
        }
    });
}
const proctoringService = {
    sendDataToMultiMediaService,
};
export default proctoringService;
